/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Footer_About_OffersInputs */

const de_commons_footer_about_offers = /** @type {(inputs: Commons_Footer_About_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angebote`)
};

/** @type {(inputs: Commons_Footer_About_OffersInputs) => LocalizedString} */
const en_commons_footer_about_offers = de_commons_footer_about_offers;

/**

* @param {Commons_Footer_About_OffersInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_footer_about_offers = /** @type {((inputs?: Commons_Footer_About_OffersInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Footer_About_OffersInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_footer_about_offers(inputs)
	return en_commons_footer_about_offers(inputs)
});